//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import foretell from "~/mixins/foretell.js";
import aos from "~/mixins/aos.js";
import API from "~/api/api";
import { titleCase } from "~/src/titlecase";
import schemaHelpers from "~/mixins/schema-helpers.js";

var parseHeadlineText = function(headlineText) {
  if (!headlineText) return null;
  return titleCase(headlineText.replace(/-/g, " ").replace(/_/g, "-")).replace(
    /Llc/g,
    "LLC"
  );
};
export default {
  layout: "default-no-sticky",
  mixins: [foretell, aos, schemaHelpers],

  data() {
    return {
      pageInfo: null,
      docSelected: "Last Will",
      customText: "",
    };
  },

  async created() {
    if (process.client) {
      if (this.$route.query.hl) {
        // remove the custom headline.
        this.customText = parseHeadlineText(this.$route.query.hl);
      }
    }
  },

  head() {
    if (this.pageInfo) {
      let domain = "https://www.legalnature.com";
      let canonicalLink = domain + "/business";
      let meta = [
        { name: "description", content: this.metaInfo.description },
        { name: "keyword", content: this.metaInfo.keyword },
        { name: "og:image", content: this.metaInfo["og-image"] },
        { name: "og:title", content: this.metaInfo.title },
        { name: "og:description", content: this.metaInfo.description },
        { name: "og:type", content: "website" },
        { name: "og:url", content: canonicalLink },
      ];
      return {
        title: this.metaInfo.title,
        meta,
        link: [
          {
            rel: "canonical",
            href: canonicalLink,
          },
        ],
      };
    } else {
      return {};
    }
  },
  jsonld() {
    if (this.pageInfo && this.metaInfo) {
      return [
        {
          "@context": "https://schema.org",
          "@type": "WebPage",
          mainEntityOfPage: {
            "@type": "WebPage",
            "@id": "https://www.legalnature.com/estate-planner",
          },
          headline: this.metaInfo.title,
          description: this.metaInfo.description,
          keywords: this.metaInfo.keyword,
          image: this.metaInfo["og-image"],
          url: "https://www.legalnature.com/estate-planner",
          author: this.schemaAuthor,
          logo: this.schemaLogo,
          publisher: {
            "@type": "Organization",
            name: "LegalNature",
            logo: this.schemaLogo,
          },
        },
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Homepage",
              item: "https://www.legalnature.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Estate Planner",
              item: "https://www.legalnature.com/estate-planner",
            },
          ],
        },
      ];
    }
  },
  mounted() {
    if (process.client) {
      this.createOrLoadUserWithForetellEvent("lnd", {
        lander_test: "bp:estate-planner",
      });
    }
  },

  asyncData({ app, query, params, redirect, error }) {
    return Promise.all([
      API.butterPages.get(app.$axios, "estate-planner", {
        preview: query.preview ? 1 : 0,
      }),
    ])
      .then((results) => {
        const pageInfo = results[0];

        return {
          pageInfo,
          loading: false,
          error: false,
        };
      })
      .catch((e) => {
        error({ message: "Error fetching data..." });
        return {
          loading: false,
          // error: true,
        };
      });
  },

  computed: {
    hero() {
      if (this.pageInfo.fields)
        return this.pageInfo.fields.components.find(
          (field) => field.table.type === "hero"
        ).table.fields.table;
    },
    lastWill() {
      if (this.pageInfo.fields)
        return this.pageInfo.fields.components.find(
          (field) => field.table.type === "last_will"
        ).table.fields.table;
    },
    livingTrust() {
      if (this.pageInfo.fields)
        return this.pageInfo.fields.components.find(
          (field) => field.table.type === "living_trust"
        ).table.fields.table;
    },
    bundle() {
      if (this.pageInfo.fields)
        return this.pageInfo.fields.components.find(
          (field) => field.table.type === "bundle"
        ).table.fields.table;
    },
    features() {
      if (this.pageInfo.fields)
        return this.pageInfo.fields.components.find(
          (field) => field.table.type === "features"
        ).table.fields.table;
    },
    notSure() {
      if (this.pageInfo.fields)
        return this.pageInfo.fields.components.find(
          (field) => field.table.type === "grey_box"
        ).table.fields.table;
    },
    legal() {
      if (this.pageInfo.fields)
        return this.pageInfo.fields.components.find(
          (field) => field.table.type === "legal"
        ).table.fields.table;
    },
    platform() {
      if (this.pageInfo.fields)
        return this.pageInfo.fields.components.find(
          (field) => field.table.type === "platform"
        ).table.fields.table;
    },
    docs() {
      if (this.pageInfo.fields)
        return this.pageInfo.fields.components.find(
          (field) => field.table.type === "docs"
        ).table.fields.table;
    },
    faqs() {
      if (this.pageInfo.fields)
        return this.pageInfo.fields.components.find(
          (field) => field.table.type === "faqs"
        ).table.fields.table;
    },
    metaInfo() {
      if (this.pageInfo.fields)
        return this.pageInfo.fields.components.find(
          (field) => field.table.type === "meta_information"
        ).table.fields.table;
    },
  },
  methods: {
    ctaLink() {
      if (this.docSelected === "Last Will")
        return "/documents/create/tw-001/epw-001";
      else if (this.docSelected === "Living Trust")
        return "/documents/create/estate-planner---trust/ept-001";
      else if (this.docSelected === "Bundle")
        return "/documents/create/tw-001/eptw-001";
    },
  },
};
